<div class="leads-details-so">
  <h1 class="page-title">Informações do Lead</h1>
  <div class="divider"></div>
  <app-info-field [data]="leadInfo" [columns]="6" />

  <h1 class="page-title" style="margin-top: 3rem">Informações da Simulação</h1>
  <div class="divider"></div>

  <div class="informacao-simulacao-sd">
    <app-info-field [data]="simulationInfo1" [columns]="6" />
    <app-info-field [data]="simulationInfo2" [columns]="6" />
    <app-info-field [data]="simulationInfo3" [columns]="6" />
    <div class="whitespace">
      <app-info-field [data]="simulationInfo4" [columns]="1" />
    </div>
  </div>
</div>
